import { Component, Input, OnInit } from '@angular/core';

import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-ver-plantilla',
  templateUrl: './ver-plantilla.component.html',
  styleUrls: ['./ver-plantilla.component.scss'],
})
export class VerPlantillaComponent implements OnInit {

  @Input() imgTemplate = '';
  @Input() nameTemplate = '';

  constructor(
    private modalController: ModalController,
  ) { }

  ngOnInit() { }

  close() {
    this.modalController.dismiss();
  }

}
